import { Navigate } from "react-router";

import { useBusinessAbilities } from "@/modules/abilities";
import { routePaths } from "@/router/route-paths";

export function LandingRedirect() {
  const { canAccessProcedures, canAccessReports, canAccessSignatures } =
    useBusinessAbilities();

  if (canAccessProcedures)
    return <Navigate to={routePaths.proceduresLanding} replace />;
  if (canAccessReports) return <Navigate to={routePaths.reports} replace />;
  if (canAccessSignatures)
    return <Navigate to={routePaths.signatures} replace />;

  // No accessible section means the user has no usable permissions on any
  // customer (zero accessible customers ⟹ zero atoms ⟹ no abilities). Log them
  // out rather than falling back to a guarded section, which RequireSection
  // would just bounce back here — an infinite redirect loop.
  return <Navigate to={routePaths.logout} replace />;
}
